import { AppLayout } from "../../../../../../layout/AppLayout";
import Button from "../../../../../../components/world/rmc/Button";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RMCCard } from "../../../../../../components/world/rmc/card";
import clsx from "clsx";
import { useState } from "react";
import { RewardForm } from "../../../modals/rewards/rewardForm";
import { HowToEarnMorePoints } from "./EarnMorePoints";
const EligibilityInfo = [
  { label: "#4", description: "Your Curren Rank" },
  { label: "1500pts", description: "Your Points" },
  { label: "5507pts", description: "Points Needed" },
];

export const Eligibility = () => {
  const [searchParams] = useSearchParams();
  const isElegible = searchParams.get("status") === "true";
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isNotEligible, setIsNotEligible] = useState(false);
  return (
    <AppLayout noNav bg={"!bg-[#111522]"}>
      <div className=" min-h-screen pt-16">
        <img
          src="/image/world/rmc/house.png"
          alt="house_image"
          className="h-[254px] mb-12 w-full"
        />
        <div className="px-4">
          {isElegible ? (
            <>
              <div className="text-center mb-12">
                <p className="text-2xl text-white font-semibold">
                  Congratulations!
                </p>
                <span className="text-xs text-[#FFFFFF80]">
                  You're ranked <span className="text-yellow-rmc_main">#1</span>{" "}
                  — You can now redeem this reward!
                </span>
              </div>
              <div className="w-full flex flex-col gap-5 mt-12">
                <Button
                  text="Claim Now"
                  className="text-lg py-[18px]"
                  onClick={() => setIsOpen(true)}
                />
                <Button
                  onClick={() => navigate(-1)}
                  text="Cancel"
                  className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
                />
              </div>
            </>
          ) : (
            <>
              <div className="text-center mb-6">
                <p className="text-2xl text-white font-semibold">
                  House Giveaway
                </p>
                <span className="text-xs text-[#FFFFFF80]">
                  Only the person ranked{" "}
                  <span className="text-yellow-rmc_main">#1</span> can redeem
                  this reward.
                </span>
              </div>
              <div className="flex items-center justify-center mb-12">
                {EligibilityInfo.map((x, i) => {
                  return (
                    <RMCCard
                      key={i}
                      className={clsx(
                        "text-center !py-3 !px-5 flex flex-col gap-1.5 border border-[#252B41]",
                        i === 0
                          ? "rounded-e-none"
                          : i === 1
                          ? "rounded-none"
                          : "rounded-s-none"
                      )}
                    >
                      <p className="text-white text-xl font-bold">{x.label}</p>
                      <span className="text-xs text-[#FFFFFF80] text-nowrap font-medium">
                        {x.description}
                      </span>
                    </RMCCard>
                  );
                })}
              </div>
              <div className="w-full flex flex-col gap-5 mt-12">
                <Button
                  onClick={() => setIsNotEligible(true)}
                  text="How to Earn More Points"
                  className="text-lg py-[18px]"
                />
                <Button
                  onClick={() => navigate(-1)}
                  text="See Leaderboard"
                  className="text-lg py-[18px] !bg-[#1A1F33] !text-[#FFFFFFBF]"
                />
              </div>
            </>
          )}
        </div>
      </div>
      {isOpen && <RewardForm setIsOpen={setIsOpen} />}
      {isNotEligible && <HowToEarnMorePoints />}
    </AppLayout>
  );
};
